import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

type MapFitBoundsProps = {
  markers: any;
  maxZoom: number;
  onFitted?: () => void;
};

const MapFitBounds: React.FC<MapFitBoundsProps> = ({
  markers,
  maxZoom,
  onFitted,
}) => {
  const map = useMap();
  useEffect(() => {
    if (markers.length > 0) {
      const bounds = L.latLngBounds(markers);
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: maxZoom });
      onFitted?.();
    }
  }, [map, markers, maxZoom, onFitted]);

  return null;
};

export default MapFitBounds;
